import { useEvent } from '@vfmfe/foundations';
import { useCallback, useState } from 'react';

const useNotifications = () => {
    const [notifications, setNotifications] = useState<
        { message: string; severity: 'info' | 'warning' | 'error' | 'success' }[]
    >([]);

    const addNotification = useCallback(
        ({ message, severity }: { message: string; severity: 'info' | 'warning' | 'error' | 'success' }) => {
            setNotifications((prevNotifications) => [{ message, severity }, ...prevNotifications]);
        },
        []
    );

    const removeNotification = useCallback((index: number) => {
        setNotifications((prevNotifications) => prevNotifications.filter((_, i) => i !== index));
    }, []);

    useEvent({
        eventName: 'show-notification',
        onReceiveEvent: (event) => {
            const { message, severity } = event.detail;
            addNotification({ message, severity });
        }
    });

    return { notifications, addNotification, removeNotification };
};

export const dispatchNotification = ({
    message,
    severity
}: {
    message: string;
    severity: 'info' | 'warning' | 'error' | 'success';
}) => {
    const event = new CustomEvent('show-notification', {
        detail: {
            message,
            severity
        }
    });
    window.dispatchEvent(event);
};

export default useNotifications;
